<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-cente mx-0">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Registrar detalle del traslado entre obras' : 'Detalle del traslado entre obras' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
            [width]="'7rem'" (onClick)="openArticleSelectionModal()"></app-custom-button>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-transfer-construction-site-detail [accessCostCenterPrice]="accessCostCenterPrice"
          [transferConstructionSiteDetails]="transferConstructionSiteDetails"
          [transferConstructionSiteDetailContract]="transferConstructionSiteDetail"
          [transferConstructionSiteContract]="transferConstructionSiteModel" [disabled]="disabledDetail"
          [costCenterPriceContract]="costCenterPriceContract" (conceptInvoicingIdEmit)="getConceptInvoicingId($event)"
          (updateListDetail)="getUpdateListDetail()" (isFormView)="getFormView($event)"
          (costCenterPriceRegister)="getCostCenterPriceOpen($event)">
        </app-register-transfer-construction-site-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
        [showCheckbox]="!this.disabledDetail" (onRecoverData)="getUpdateListDetail()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>
<!-- Precios C.Costos -->
<app-custom-modal #costCenterPriceRegisterModal [label]="'Precios C.Costos - Captura'"
  [header]="'Precios C.Costos - Captura'" [inputs$]="inputsForCostCenterPriceRegisterModals$" [width]="'50rem'"
  [children]="componentRegisterModal" hidden (params)="getCostCenterPriceRegister($event.costCenterPriceModel)">
</app-custom-modal>